function Header() {
  return (
    <div className="text-center mb-8">
      <h1 className="text-4xl font-bold text-gray-800 mb-2 drop-shadow-sm">
        STI College GWA Calculator
      </h1>
      <p className="text-gray-600">Calculate your General Weighted Average</p>
    </div>
  );
}

export default Header;
